<mat-accordion
    displayMode="flat"
    togglePosition="before">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>{{ languageSettings.PSTWebCreatedInLabel }}</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-chip-listbox
            st-click-stop-propagation
            class="st-filter-manage-team-members-options"
            [(ngModel)]="group"
            (change)="onTeamChange($event)">
            <mat-chip-option
                selected
                [value]="all">
                {{ languageSettings.PSTWebAllLabel }}
            </mat-chip-option>
            <mat-chip-option [value]="global">{{ languageSettings.PSTWebGlobalLabel }}</mat-chip-option>
            <mat-chip-option [value]="personal">{{ languageSettings.PSTWebPersonalLabel }}</mat-chip-option>
            @for (t of teams; track t) {
                <mat-chip-option [value]="t.id">{{ t.title }}</mat-chip-option>
            }
        </mat-chip-listbox>
    </mat-expansion-panel>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>{{ languageSettings.PSTWebCastObjectsCreatedBy }}</mat-panel-title>
        </mat-expansion-panel-header>
        <st-staff-id-list-multiple
            [label]="languageSettings.PSTWebCastObjectsCreatedBy"
            [value]="creators()"
            (changed)="onCreatorChange($event)" />
    </mat-expansion-panel>
</mat-accordion>
